var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiktokicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.5583,
    r: 20,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.895 8.33537H21.3457V25.665C21.3457 27.682 19.6962 29.3171 17.6792 29.3171C15.6781 29.3171 14.0416 27.6949 14.0416 25.6939C14.0416 23.6928 15.6638 22.0706 17.6648 22.0706C18.4068 22.0706 18.8324 22.2219 18.8324 22.2219V17.5835H17.6532C13.1308 17.5835 9.46463 21.2496 9.46463 25.772C9.46463 30.2944 13.1441 33.9605 17.6664 33.9605C22.2036 33.9605 25.895 30.2824 25.895 25.7453V16.538C27.6577 18.1578 30.4022 18.6601 31.8354 18.6899V14.2846C27.7593 14.0977 26.3134 10.7917 25.9383 8.83851C25.9064 8.67247 25.895 8.33537 25.895 8.33537Z",
    fill: "#FE0B55"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5948 7.15611H20.0456V24.4858C20.0456 26.5027 18.396 28.1378 16.379 28.1378C14.378 28.1378 12.7414 26.5157 12.7414 24.5146C12.7414 22.5135 14.3636 20.8913 16.3647 20.8913C17.1066 20.8913 17.5323 21.0426 17.5323 21.0426V16.4042H16.353C11.8306 16.4042 8.16449 20.0703 8.16449 24.5927C8.16449 29.1151 11.8439 32.7812 16.3663 32.7812C20.9034 32.7812 24.5948 29.1032 24.5948 24.5661V15.3587C26.3576 16.9786 29.102 17.4809 30.5352 17.5106V13.1053C26.4591 12.9185 25.0133 9.61241 24.6382 7.65924C24.6063 7.4932 24.5948 7.15611 24.5948 7.15611Z",
    fill: "#00F0E8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokicon);
export default __webpack_public_path__ + "static/media/tiktokicon.16731088243400f466affa8917dbc4dc.svg";
export { ForwardRef as ReactComponent };